import React, { useEffect, useState } from 'react';
import GenericTable from './GenericTable';

const PaymentsManagementExample = ({ columns, defaultRows, searchText, onRowSelect = ()=>{}, defaultHeight='400px' }) => {
  // אתחול המצב עם הערכים שמתקבלים מהפרופס
  const [paymentRows, setPaymentRows] = useState([...defaultRows]);

  useEffect(() => {
    setPaymentRows([...defaultRows])
  }, [defaultRows]);

  const handlePaymentsChange = (newRows) => {
    // setPaymentRows(newRows);
  };

  // פונקציה ליצירת מבנה של שורה
  const createRowStructure = (columns) => {
    return columns.reduce((acc, column) => {
      acc[column.field] = '';
      return acc;
    }, {});
  };

  return (
    <div>
      {columns && defaultRows && (
        <GenericTable
          columns={columns}
          defaultRows={paymentRows}
          searchText={defaultRows}
          onRowsChange={handlePaymentsChange}
          rowStructure={createRowStructure(columns)}
          onRowSelect={onRowSelect}
          defaultHeight={defaultHeight}
        />
      )}
    </div>
  );
};

export default PaymentsManagementExample;
